'use client';

import { useEffect, useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { EpStepContent, EpStepSelect } from '../components';
import { notificationService } from '../../../services/notificationService';
import { useTranslation as t } from '../../../hooks/useTranslation';
import { IEpSelectOptionsListData } from '../../../interfaces';
import { useHospitalStore } from '../../../stores';

// type data = {
//   id: string,
//   name: string
// };

export default function NotifierOccupationInput({
  translations,
}: {
  translations: unknown;
}) {
  const { getOccupations } = notificationService;
  const { hospitalInfo } = useHospitalStore();

  const { data } = getOccupations(hospitalInfo?.HospitalId);

  const { unregister } = useFormContext();
  const NotificationIncident = useWatch({
    name: 'notificationIncidentId.inputValue',
  });
  const [NotifierOccupationItens, setNotifierOccupationItens] =
    useState<IEpSelectOptionsListData[]>();

  useEffect(() => {
    unregister('NotifierOccupation');
    setNotifierOccupationItens(data?.itens);
  }, [data, NotificationIncident, unregister]);

  if (!NotifierOccupationItens || NotifierOccupationItens.length === 0) {
    return null;
  }

  return (
    <>
      <EpStepContent.Label label={t(translations, 'You are') + ' *'}>
        <EpStepSelect
          data={NotifierOccupationItens}
          disabled={NotificationIncident === ''}
          errorMessage={t(translations, '* Required Fied')}
          registerId={'occupationId'}
        />
      </EpStepContent.Label>
    </>
  );
}
